<template>
  <div>
    <div class="columns" v-for="(row, idx) in rows" :key="idx">
      <a class="column" v-for="item in row" :key="item.id" @click="open(item)">
        <card>
          <card-content>
            <div class="media">
              <div class="media-left">
                <image-box
                  :url="item.image_url"
                  dimension="is-96x96"
                ></image-box>
              </div>
              <div class="media-content">
                <p>{{ item.name }}</p>
              </div>
            </div>
          </card-content>
        </card>
      </a>
      <div class="column" v-if="row.length < itemsInRowCount"></div>
      <div class="column" v-if="row.length == 1"></div>
    </div>
  </div>
</template>
<script>
import { appSettings } from "@/app.settings";
import profile from "@/services/profile";

export default {
  name: "ApplicationList",
  data() {
    return {
      itemsInRowCount: 3,
      items: [],
      redirectEndpoint: ""
    };
  },
  methods: {
    fetch() {
      profile.getApps().then(
        resp => {
          this.items = resp.data.filter(_ => _.visible);
        },
        err => {
          console.log(err);
        }
      );
    },
    open(item) {
      if (item.type !== "desktop") {
        if (item.openUrl !== undefined && item.openUrl !== "") {
          window.location.href = item.openUrl;
          return;
        }
        window.location.href =
          appSettings.baseUrl +
          "/apps/open?id=" +
          item.id +
          "&type=" +
          item.type;
      }
    }
  },
  mounted() {
    this.fetch();
  },
  computed: {
    rows() {
      let result = [];
      let items = [];
      this.items.forEach((item, idx) => {
        items.push(item);
        if (
          items.length === this.itemsInRowCount ||
          idx == this.items.length - 1
        ) {
          result.push(items);
          items = [];
        }
      });
      return result;
    }
  }
};
</script>
